import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
export default async function areLayersLoaded(map) {
        await map.when(); 
        const layerPromises = map.layers.items.map(layer => 
          reactiveUtils.whenOnce(() => layer.loaded)
        );
        await Promise.all(layerPromises); 
        return true;  
}